export default __webpack_public_path__ + "static/media/part_4_con.cc4f883c.gif";